"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, useMemo } from "react";
import { cleanProps, cn } from "../../utils/index.js";
import { Scrim } from "../Scrim/index.js";
import { ToolbarContext } from "./Toolbar.context.js";
import { toolbarVariantKeys, toolbarVariants } from "./Toolbar.variants.js";
const Toolbar_Toolbar = /*#__PURE__*/ forwardRef(function({ buttonLeft, itineraryButton, buttonRight1, buttonRight2, className, condensed, emphasis, animate, ...props }, ref) {
    const { root, buttonLeftSlot, itinerarySlot, buttonRightSlot } = toolbarVariants({
        condensed,
        emphasis,
        animate
    });
    const domProps = cleanProps(props, toolbarVariantKeys);
    const contextValue = useMemo(()=>({
            emphasis
        }), [
        emphasis
    ]);
    const content = /*#__PURE__*/ jsx(ToolbarContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ jsxs("div", {
            ref: ref,
            className: cn(root(), className),
            ...domProps,
            children: [
                buttonLeft && /*#__PURE__*/ jsx("div", {
                    className: buttonLeftSlot(),
                    children: buttonLeft
                }),
                itineraryButton && /*#__PURE__*/ jsx("div", {
                    className: itinerarySlot(),
                    children: itineraryButton
                }),
                (buttonRight1 || buttonRight2) && /*#__PURE__*/ jsxs("div", {
                    className: buttonRightSlot(),
                    children: [
                        buttonRight1,
                        buttonRight2
                    ]
                })
            ]
        })
    });
    if ('bold' === emphasis) return /*#__PURE__*/ jsx(Scrim, {
        isTop: true,
        children: content
    });
    return content;
});
export { Toolbar_Toolbar as Toolbar };
